import React from 'react';
import './WatchOnRoku.css';

// Renders a "Watch on Roku" link only once the Roku channel is live and its
// Channel Store URL is configured. Until REACT_APP_ROKU_CHANNEL_URL is set,
// this renders nothing — so it can ship before Roku certification approves
// the channel without ever showing a dead link.
const ROKU_CHANNEL_URL = process.env.REACT_APP_ROKU_CHANNEL_URL || '';

const WatchOnRoku = ({ variant = 'button', label = 'Watch on your TV', className = '' }) => {
  if (!ROKU_CHANNEL_URL) return null;

  return (
    <a
      href={ROKU_CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`watch-on-roku watch-on-roku--${variant} ${className}`.trim()}
      aria-label="Watch Canira TV on Roku"
    >
      <span className="watch-on-roku__brand">ROKU</span>
      <span className="watch-on-roku__text">{label}</span>
    </a>
  );
};

export default WatchOnRoku;
